if (!global._babelPolyfill) {
	require('@babel/polyfill');
}

import { V2_APPLICATION_PATH } from 'AppConstants';
import React from 'react';
import { hydrate } from 'react-dom';
import Loadable from 'react-loadable';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import configureStore from '../redux/store';
import SeoApp from './index';
import { StyleSheetManager } from 'styled-components';
import { shouldForwardProp } from 'UtilityComponents/Util';

let preloadedState = {};
if (typeof window !== 'undefined') {
	preloadedState = window.__PRELOADED_STATE__;
	delete window.__PRELOADED_STATE__;
}
const { store } = configureStore(preloadedState);

Loadable.preloadReady().then(() => {
	hydrate(
		<BrowserRouter basename={V2_APPLICATION_PATH}>
			<Provider store={store}>
				<StyleSheetManager shouldForwardProp={shouldForwardProp}>
					<SeoApp />
				</StyleSheetManager>
			</Provider>
		</BrowserRouter>,
		document.querySelector('#root')
	);
});
